(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_3920bcd"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('runway-gallery')){customElements.define('runway-gallery',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;const button=this.querySelector('button');if(!button)return;button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')!=='true';this.querySelectorAll('[data-extra]').forEach(item=>item.hidden=!expanded);button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?button.dataset.close:button.dataset.open;});}});}
  } catch(e) { console.error(e); }
})();

})();
